<!-- 2 columns form -->
<form name="categoryform" [formGroup]="categoryForm" novalidate>
  <div class="panel panel-flat">
    <div class="panel-heading">
      <h5 class="panel-title">Product Category</h5>
      <div class="heading-elements">
        <ul class="icons-list">
          <li>
            <a data-action="reload" (click)="reset()"></a>
          </li>
        </ul>
      </div>
      <hr class="divider">
    </div>

    <div class="panel-body">

      <div class="row">
        <div class="col-md-6">


          <fieldset>
            <legend class="text-semibold">
              <i class="icon-list position-left"></i> Categories
            </legend>

            <!-- <dropzone [config]="config" [message]="'Click or drag category picture here'"
              (error)="onUploadError($event)" (success)="onUploadSuccess($event)"></dropzone>
 -->

            <table class="table datatable-column-search-inputs">
              <thead>
                <tr>
                  <th>Title</th>
                  <th>Interval</th>
                  <th>Amount</th>
                  <th>Remark</th>
                  <th class="text-center">Actions</th>
                </tr>
              </thead>
              <tbody>
                <tr
                  *ngFor="let category of categories | paginate: { id: 'categories',itemsPerPage: itemsPerPage,currentPage: currentPage,totalItems: totalItems }">
                  <td>{{category.title}}</td>
                  <td>{{category.interval}}</td>
                  <td>{{category.amount}}</td>
                  <td>{{category.remark}}</td>

                  <td class="text-center">
                    <ul class="icons-list">
                      <li class="dropdown">
                        <a href="" class="dropdown-toggle" data-toggle="dropdown">
                          <i class="icon-menu9"></i>
                        </a>

                        <ul class="dropdown-menu dropdown-menu-right">
                          <li>
                            <!--  <a href="" [routerLink]="['/categoryadd']" [queryParams]="{'id':category.id}"> -->
                            <a href="javascript:void(0);" (click)="editCategory(category)">
                              <i class="icon-file-pdf"></i>Update</a>
                          </li>
                          <li>
                            <a href="">
                              <i class="icon-file-excel"></i>Delete</a>
                          </li>
                        </ul>
                      </li>
                    </ul>
                  </td>
                </tr>
                <tr *ngIf="categories.length <=0">
                  <td colspan="5" class="text-center"> <i class="icon-info22">&nbsp;</i>No Categories yet!</td>
                </tr>
              </tbody>
            </table>


            <div class="row">
              <!-- <p class="text-left" style="color:#00695C;font-weight:600;padding:10px;">{{val}}</p> -->
              <div class="text-center">

                <pagination-controls id="categories" (pageChange)="pageChanged(currentPage = $event)">
                </pagination-controls>

                <br>
              </div>

            </div>

          </fieldset>
        </div>

        <div class="col-md-1"></div>
        <div class="col-md-5">


          <fieldset>
            <legend class="text-semibold">
              <i class="icon-reading position-left"></i> Category Specs
            </legend>

            <div class="row">
              <div class="col-lg-4">
                <div class="form-group required">
                  <span class="control-label"> Title: </span>
                  <input type="text" name="title" required formControlName="title" class="form-control"
                    placeholder="category title">
                  <div class="help-block" *ngIf="title.invalid && (title.dirty || title.touched)">
                    <p class="text-danger">
                      <i class="icon-cancel-circle2 position-left text-red"></i> Category title is required
                    </p>
                  </div>
                </div>
              </div>
              <div class="col-lg-4">
                <div class="form-group required">
                  <span class="control-label"> Amount: </span>
                  <input type="number" name="amount" required formControlName="amount" class="form-control"
                    placeholder="category equb amount">
                  <div class="help-block" *ngIf="amount.invalid && (amount.dirty || amount.touched)">
                    <p class="text-danger">
                      <i class="icon-cancel-circle2 position-left text-red"></i> Category amount is required
                    </p>
                  </div>
                </div>
              </div>

              <div class="col-lg-4">
                <div class="form-group required">
                  <span class="control-label"> Interval: </span>
                  <ng-select [items]="intervals" placeholder="" formControlName="interval" bindLabel="text"
                    bindValue="id" required>
                  </ng-select>
                  <div class="help-block" *ngIf="interval.invalid && (interval.dirty || interval.touched)">
                    <p class="text-danger">
                      <i class="icon-cancel-circle2 position-left text-red"></i> Category's ekub interval is required
                    </p>
                  </div>
                </div>
              </div>
            </div>


            <div class="row">

              <div class="form-group">
                <label>&nbsp;</label>
                <label>Remark:</label>
                <textarea rows="5" cols="5" class="form-control" name="remark" formControlName="remark"
                  placeholder="Additional information . . ." required></textarea>
                <div class="help-block" *ngIf="remark.invalid && (remark.dirty || remark.touched)">
                  <p class="text-danger">
                    <i class="icon-cancel-circle2 position-left"></i>Please write small description about the category
                  </p>
                </div>
              </div>
            </div>

          </fieldset>

          <div class="text-right">

            <!--  <button class="btn bg-slate-800" (click)="addNews(category.id)" type="submit" data-style="slide-right" [ladda]="isLoading" [disabled]="newsForm.invalid">
              <span *ngIf="!category.id">Save News</span>
              <span *ngIf="category.id">Update News</span>
              <i class="icon-floppy-disk position-right"></i>
            </button> -->
            <button class="btn bg-slate-800" (click)="addCategory()" type="submit" data-style="slide-right"
              [disabled]="categoryForm.invalid">
              <span *ngIf="operation=='add'">Save Category</span>
              <span *ngIf="operation!='add'">Update Category</span>
              <i class="icon-floppy-disk position-right"></i>
            </button>

          </div>


        </div>

      </div>





    </div>
  </div>
</form>
<!-- /2 columns form -->